import { useState } from 'react'
import { useParams } from 'react-router'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import { questionBankService } from 'api/administration/questionBank'
import { useNotification } from 'hooks/notifications/useNotification'
import lessonBlocksList from 'api/administration/blocks/List'
import * as fromActions from 'store/actions/blocks.action'
import { useTranslationRankmi } from 'helpers/translations.helper'

interface IProps {
  evaluationId?: number | null
  close: () => void
}

const useSave = ({ evaluationId, close }: IProps) => {
  const { lessonId } = useParams<{ lessonId: string }>()
  const tRelative = useTranslationRankmi({
    prefix: 'administration.blocks.type.questionBankV2.buttons',
  })
  const appDispatch = useAppDispatch()
  const notification = useNotification()
  const [isProcessing, setIsProcessing] = useState(false)
  const data = useAppSelector(slices.questionBank.data)
  const totalBlocks = useAppSelector(({ blocks }) => blocks.list?.length || 0)

  const refreshBlocks = async () => {
    const data = await lessonBlocksList(+lessonId)
    appDispatch(fromActions.Actions.getLessonBlocksListSuccess(data))
  }

  const saveData = () => {
    setIsProcessing(true)
    if (evaluationId) {
      questionBankService
        .updateEvaluation(evaluationId, data)
        .then(async () => {
          notification.success(tRelative(`notifications.evaluationUpdated`))
          await refreshBlocks()
          close()
        })
        .catch(() => {
          notification.warning(
            tRelative(`notifications.errorUpdatingEvaluation`)
          )
        })
        .finally(() => {
          setIsProcessing(false)
        })
    } else {
      questionBankService
        .createEvaluation({
          blockInstance: {
            order: totalBlocks + 1,
            lesson_id: +lessonId,
          },
          evaluation: data,
        })
        .then(async () => {
          notification.success(tRelative(`notifications.evaluationCreated`))
          await refreshBlocks()
          close()
        })
        .catch(() => {
          notification.warning(
            tRelative(`notifications.errorCreatingEvaluation`)
          )
        })
        .finally(() => {
          setIsProcessing(false)
        })
    }
  }

  return { saveData, isProcessing }
}

export default useSave
